<template>
  <ModalDialog
    ref="dialog"
    title="Add Relief Cut"
    icon="fa-scalpel-path"
    :showFooter="true"
    submitTitle="Add Relief Cut"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3" @submit="onFormSubmitted">
      <template v-if="isInLineReliefCut">
        <FormRow label="Distance From Edge" helpTip="Distance from the endpoint of the cutout to start the relief cut">
          <FormInputText ref="inlineDistanceFromEdgeEntry" type="number" addon="mm" v-model="distanceFromEdge" field="distanceFromEdge" />
        </FormRow>
        <FormRow label="Relief Cut Height" helpTip="The height of the relief cut from the start point outwards">
          <FormInputText type="number" addon="mm" v-model="reliefCutHeight" field="reliefCutHeight" />
        </FormRow>
      </template>
      <template v-if="!isInLineReliefCut">
        <FormRow label="Inset Distance" helpTip="Distance inset from the edge of the cutout to start the relief cut">
          <FormInputText ref="distanceFromEdgeEntry" type="number" addon="mm" v-model="distanceFromEdge" field="distanceFromEdge" />
        </FormRow>
      </template>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'WaterjetAddReliefCutDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isInLineReliefCut: Boolean,
    maxDistanceFromEdge: Number
  },
  data() {
    return {
      form: {},
      distanceFromEdge: 0,
      reliefCutHeight: 10
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      if(this.isInLineReliefCut) {
        this.$refs.inlineDistanceFromEdgeEntry.focus()
        this.$refs.inlineDistanceFromEdgeEntry.select()

        this.reliefCutHeight = Math.min(30, Math.round(this.maxDistanceFromEdge / 2))
      } else {
        this.$refs.distanceFromEdgeEntry.focus()
        this.$refs.distanceFromEdgeEntry.select()
      }
    })
  },
  computed: {
  },
  methods: {
    show() {
      this.form = {}

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()

      var reliefCutData = {
        distanceFromEdge: parseInt(this.distanceFromEdge || 0),
        reliefCutHeight: parseInt(this.reliefCutHeight || 0)
      }

      if(reliefCutData.distanceFromEdge <= 0) {
        this.addFormFieldError(this.form, 'distanceFromEdge', 'Distance from edge must be valid')
        return
      }
      if(reliefCutData.distanceFromEdge >= this.maxDistanceFromEdge && this.maxDistanceFromEdge > 0) {
        this.addFormFieldError(this.form, 'distanceFromEdge', `Distance from edge must be less than ${this.maxDistanceFromEdge}mm`)
        return
      }

      if(this.isInLineReliefCut) {
        if(reliefCutData.reliefCutHeight <= 0) {
          this.addFormFieldError(this.form, 'reliefCutHeight', 'Relief cut must be valid')
          return
        }
      }

      this.modalClosed(reliefCutData)
      this.hide()
    },
    onFormSubmitted(ev) {
      ev.preventDefault()
      this.onSubmitted()
    }
  }
}
</script>